/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type SimpleImage = {
  src: string
  alt: string
}

export type Image = {
  src: string
  srcMobile: string
  alt: string
  width: number
  height: number
  widthMobile?: Maybe<number>
  heightMobile?: Maybe<number>
}

/* Schemas */
export const SimpleImageSchema = z.object({
  src: z.string(),
  alt: z.string(),
})

export const ImageSchema = z.object({
  src: z.string(),
  srcMobile: z.string(),
  alt: z.string(),
  width: z.number(),
  height: z.number(),
  widthMobile: z.nullish(z.number()),
  heightMobile: z.nullish(z.number()),
})

/* Schemas validation */
type TestSimpleImage = ExpectTrue<
  Equal<SimpleImage, z.infer<typeof SimpleImageSchema>>
>
type TestImage = ExpectTrue<Equal<Image, z.infer<typeof ImageSchema>>>
